<template>
  <img v-if="url!==null" :src="url">
</template>

<script>
// const log = console.log
import firebaseSrv from '@/services/firebaseSrv.js'
import { setTimeout } from 'timers'
export default {
  props: ['photo'],
  data() {
    return {
      url: null
    }
  },
  mounted() {
    const path = `${this.photo.folderName}/slide/thumb_slide_${
      this.photo.fileName
    }`
    firebaseSrv
      .getImage(path)
      .then(response => {
        // console.log('Here:' + JSON.stringify(response))
        return (this.url = response)
      })
      .catch(() => {
        setTimeout(() => {
          firebaseSrv
            .getImage(this.path)
            .then(response => {
              // console.log('Second promise:' + JSON.stringify(response))
              return (this.url = response)
            })
            .catch(() => {
              setTimeout(() => {
                firebaseSrv
                  .getImage(this.path)
                  .then(response => {
                    // console.log('Third promise:' + JSON.stringify(response))
                    return (this.url = response)
                  })
                  .catch(() => {
                    setTimeout(() => {
                      firebaseSrv
                        .getImage(this.path)
                        .then(response => {
                          return (this.url = response)
                        })
                        .catch(() => {
                          // console.log('Given up')
                          return (this.url = this.photo.filePath)
                        })
                    }, 3000)
                  })
              }, 2500)
            })
        }, 2000)
      })
    /*
      .catch(error => {
        const notification = {
          title: 'There is problem accessing files',
          type: 'error',
          code: error.code,
          message: error.message
        }
        return this.$store.dispatch('notification/add', notification, {
          root: true
        })
      })
      */
  }
}
</script>

<style scoped>
@media (min-width: 768px) {
  .image-wrapper {
    text-align: right;
  }
}
@media (min-width: 992px) {
  .image-wrapper {
    text-align: right;
  }
}

img {
  width: 100%;
  max-height: 100vh;
}

@media (min-width: 576px) {
  img {
    width: auto;
    max-width: 100%;
    max-height: 95vh;
  }
}
</style>

//
